import { fetchPostalCodeInputValidation } from "../api"

export async function validatePostalCode(value: string, abortSignal: AbortSignal): Promise<string | undefined> {
    return (await fetchPostalCodeInputValidation(value, abortSignal)).errorMessage
}
